import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { io } from "socket.io-client";
import { serverURL } from './config';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';

export const socket = io(serverURL);

const { fetch: originalFetch } = window;
window.fetch = async (...args) => {
    let [resource, config] = args;
    const user = localStorage.getItem('user');
    if (user && config) {
        const parsedData = JSON.parse(user);
        const token = parsedData.token;
        if (config.headers) {
            config["headers"]['Authorization'] = `Bearer ${token}`
        } else {
            let headers = { "Authorization": `Bearer ${token}` }
            config.headers = headers;
        }
    }
    const response = await originalFetch(resource, config);
    return response;
};

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// ReactDOM.render(<App />, document.getElementById('root'));